import availableJobCategories from '@/helpers/availableJobCategoriesHelper'
import {
    availableCastingJobTypes,
    availableMasterOfCeremoniesJobTypes,
    availableEventSupportJobTypes,
    availableBarsRestaurantsJobTypes
} from '@/helpers/availableJobTypeHelper'
import availableHairColors from '@/helpers/hairColorHelper'
import availableEthnicities from '@/helpers/ethnicityHelper'
import availableLanguages from '@/helpers/availableLanguagesHelper'

export default function () {
    return {
        reachedEnd: false,
        filters: {
            category: null,
            types: [],
            'user.address.city': null,
            'user.gender': null,
            'fees.type': null,
            'fees.amount[lte]': null,
            'user.name': null,
            hairColor: null,
            'height[gte]': null,
            ethnicity: null,
            'inArray[user.languages]': [],
            'user.symplaParticipations.event.id': [],
            'user.symplaParticipations.profiles': null
        },
        showVaccinationCertificateFilter: false,
        filterVaccinationCertificate: false,
        profiles: [],
        currentProfileIndex: 0,
        availableJobCategories,
        availableCastingJobTypes,
        availableMasterOfCeremoniesJobTypes,
        availableEventSupportJobTypes,
        availableBarsRestaurantsJobTypes,
        availableHairColors,
        availableEthnicities,
        availableLanguages,
        availableCities: [],
        citySearchInput: null,
        loadingCities: false,
        cityDebounceTimeout: null,
        cityRequestId: 0,
        showNoProfilesFound: false,
        showSymplaEvents: false,
        symplaEvents: [],
        showCoursesDescription: false,
        nameFilterDebounceTimeout: null
    }
}
